const theme = {
  boxShadow: '18px 18px 30px #D1D9E6, -18px -18px 30px #f5f5f5',
  primary: '#1890ff',
};

export default theme;
